import { Input, Table, Tag } from 'antd'

import { calculateLineTotal } from '@utils/calculations'
import { numberWithSpacesIntl } from '@utils/numberWithSpaces'
import {
	calculateKvmPrices,
	calculateShtPrices,
	calculateMetrPriceServices,
	calculateMetrPriceParametr,
} from '@utils/salesOrderCalculations'

const SummaryTable = ({
	t,
	summarizedData,
	isAdmin,
	handleKoefitsentChange,
	selectedServices,
}) => {
	const columnsKoefitsent = [
		{
			title: t('item'),
			dataIndex: 'itemName',
			key: 'itemName',
			width: 200,
		},
		{
			title: t('kv.m'),
			dataIndex: 'lineTotalWithKoef',
			key: 'lineTotalWithKoef',
			render: (totalWithKoef) => (
				<span className="w-full">
					{numberWithSpacesIntl(totalWithKoef)}
				</span>
			),
		},
		{
			title: t('amountInWhs'),
			dataIndex: 'amountInWhs',
			key: 'amountInWhs',
			render: (text) => (
				<span className="w-full">
					{text ? new Intl.NumberFormat().format(text) : text}
				</span>
			),
		},
		{
			title: t('actions'),
			dataIndex: 'amountInWhs',
			key: 'amountInWhs',
			render: (text) => (
				<span className="w-full">
					{+text <= 0 && <Tag color="red">{t('itemIsNotInWhs')}</Tag>}
				</span>
			),
		},
		{
			title: t('totalMiqdor'),
			dataIndex: 'lineTotal',
			key: 'lineTotal',
			render: (_, record) => {
				const selectedPrices = calculateKvmPrices(
					record?.selectedServices,
				)

				const koef = record.koefitsent || 1
				const totalWithKoef = record.lineTotalWithKoef * koef // Use the precomputed summarized value

				const shtPrices = calculateShtPrices(selectedServices)

				const metrPricesServices =
					calculateMetrPriceServices(selectedServices)

				const metrPricesParametr =
					calculateMetrPriceParametr(selectedServices)

				//	Bunda usluga,item,Figuraniki hisoblidi koefitsent bn
				const lineTotal = calculateLineTotal(
					record.price,
					0, //Endi Uslugalarni Narxini koefitsent bn hisoblanmidi
					totalWithKoef,
				)

				//	Bunda faqat itemmikini hisoblidi koefitsent bn
				// const lineTotal =
				// 	calculateLineTotal(
				// 		record.price,
				// 		0, //Endi Uslugalarni Narxini koefitsent bn hisoblanmidi
				// 		totalWithKoef,
				// 	) + selectedPrices

				// Update the summarized record with the calculated lineTotal (optional)
				record.lineTotal = lineTotal

				return (
					<span className="w-full">
						{numberWithSpacesIntl(lineTotal || 0)}
					</span>
				)
			},
		},
		{
			title: t('Koefitsent'),
			dataIndex: 'koefitsent',
			key: 'koefitsent',
			render: (_, record) => {
				return (
					<div className="flex flex-col gap-3 ">
						<Input
							type="number"
							onWheel={(e) => e.target.blur()}
							min={-1}
							suffix="%"
							controls={false}
							value={record.koefitsent}
							disabled={!isAdmin}
							onChange={(e) =>
								handleKoefitsentChange(
									e.target.value,
									record.itemName,
								)
							}
							className="w-full"
						/>
						{record.koefitsent <= 0 && (
							<Tag color="red">{t('koefitsentLessThanZero')}</Tag>
						)}
					</div>
				)
			},
		},
	]

	return (
		<Table
			columns={columnsKoefitsent}
			dataSource={summarizedData}
			pagination={false}
			className="border-1 mt-2 border-black"
			bordered
			scroll={{ x: 'max-content' }}
		/>
	)
}

export default SummaryTable
